import "./App.css";

import React, { useState } from "react";
import { useMap } from "react-map-gl";

import HighstreetMap from "./map/HighstreetMap";

import { useMediaQuery, useTheme, CssBaseline } from "@mui/material";
import { styled, ThemeProvider } from "@mui/material/styles";
import { darkTheme } from "./themes/theme";

import SidebarMobile from "./sidebar/SidebarMobile";
import SidebarDesktop from "./sidebar/SidebarDesktop";
import Tour from "./tour/Tour";
import Legend from "./legend/Legend";

const Root = styled("main")(() => ({
  height: "100%",
  width: "100%",
  maxHeight: "100%",
  maxWidth: "100%",
}));

const MapContainer = styled("div", {
  shouldForwardProp: (prop) =>
    prop !== "open" && prop !== "isMobile" && prop !== "isTouchDevice",
})(({ theme, open, isMobile, isTouchDevice }) => ({
  position: "absolute",
  height: isMobile && open && !isTouchDevice ? "50%" : "100%",
  width: open && !isMobile ? `calc(100% - ${theme.drawerWidth}px)` : "100%",
  transition: theme.transitions.create(["width", "height"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  top: 0,
  left: 0,
  right: 560,
}));

function App() {
  const [drawerOpen, setDrawerOpen] = useState(true);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTouchDevice = "ontouchstart" in window || navigator.msMaxTouchPoints;
  const { map } = useMap();

  const handleSetDrawerOpen = async (newDrawerOpen) => {
    setDrawerOpen(newDrawerOpen);

    if (newDrawerOpen) {
      setTimeout(resizeMap, theme.transitions.duration.enteringScreen);
      return;
    }
    const resizeMapInterval = setInterval(resizeMap, 5);
    setTimeout(
      () => clearInterval(resizeMapInterval),
      theme.transitions.duration.leavingScreen + 500
    );
  };

  const resizeMap = () => {
    if (map) {
      map.resize();
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <Root>
        <CssBaseline />
        <Tour />
        {!isMobile && <Legend className="legend" id="legend" />}
        <MapContainer
          open={drawerOpen}
          isMobile={isMobile}
          isTouchDevice={isTouchDevice}>
          <HighstreetMap />
        </MapContainer>
        {isMobile ? (
          <SidebarMobile open={drawerOpen} setOpen={handleSetDrawerOpen} />
        ) : (
          <SidebarDesktop open={drawerOpen} setOpen={handleSetDrawerOpen} />
        )}
      </Root>
    </ThemeProvider>
  );
}

export default App;
